import $ from "jquery";
import { application } from "../application/application";
import { services } from "../services/notificationService";
import { forms } from "../framework/forms";

const contentType = {
    APPLICATION_JSON: "application/json; charset=utf-8",
    APPLICATION_X_WWW_FORM_URLENCODED: "application/x-www-form-urlencoded; charset=UTF-8",
    MULTIPART_FORM_DATA: "multipart/form-data; charset=utf-8",
    TEXT_PLAIN: "text/plain; charset=utf-8"
};

let ShowSpinner = false;

function get(params) {
    return makeAjaxRequest(params);
}
function post(params) {
    params.method = "POST";
    return makeAjaxRequest(params);
}
function put(params) {
    params.method = "PUT";
    return makeAjaxRequest(params);
}
function deleteItem(params) {
    params.method = "DELETE";
    return makeAjaxRequest(params);
}

function patch(params) {
    params.method = "PATCH";
    return makeAjaxRequest(params);
}

function setShowSpinner(showspinner) {
    ShowSpinner = showspinner;
}

function makeAjaxRequest(params) {
    const _showSpinner = params.showSpinner || ShowSpinner;
    const _method = params.method || "GET";
    const _data = params.data || "";
    const _headers = params.headers || {};
    const _contentType = params.contentType || contentType.APPLICATION_JSON;
    const _url = params.url || "";
    const _successMsg = params.successMsg || "";
    if (_showSpinner === "True") {
        forms.showSpinner();
    }

    const requestPayload = {
        url: _url,
        data: _data !== "" && _contentType.startsWith("application/json") ? JSON.stringify(_data) : _data,
        headers: _headers,
        contentType: _contentType,
        method: _method,
        success: function() {
            if (_showSpinner) {
                forms.hideSpinner();
            }
            if (_successMsg !== "") {
                services.notificationService.success(_successMsg);
            }
        },
        statusCode: {
            401: function() {
                window.location.href =
                    application.baseUrl + "/Account/Login?ReturnUrl=" + window.location.pathname;
            },
            500: function() {
                if (_showSpinner) {
                    forms.hideSpinner();
                }
                services.notificationService.error("An unexpected error has occurred. Please try again later.");
            },
            404: function() {
                if (_showSpinner) {
                    forms.hideSpinner();
                }
                services.notificationService.error("An unexpected error has occurred. (404)");
            }
        }
    };

    return $.ajax(requestPayload);
}

export const dataaccess = {
    contentType: contentType,
    get: get,
    post: post,
    put: put,
    delete: deleteItem,
    patch: patch,
    setShowSpinner: setShowSpinner
};